module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "overflow-y": "hidden",
      "max-width": "100%"
    }
  }, [_c('table', {
    class: _vm.tableClass,
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [(_vm.checkbox) ? _c('th', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checkAll
    },
    on: {
      "change": function($event) {
        return _vm.toggleAllCheckboxes($event.target.checked)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c('th', {
      class: column.title.columnClass,
      attrs: {
        "contenteditable": "true"
      }
    }, [(_vm.isSortable(column.content)) ? [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.orderBy($event, column.content)
        }
      }
    }, [(_vm.appendParams.sort.field == column.content.data) ? _c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: {
        'fa-caret-down': _vm.appendParams.sort.direction === 'asc',
        'fa-caret-up': _vm.appendParams.sort.direction === 'desc'
      }
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n              " + _vm._s(column.title.caption) + "\n            ")])])] : [_c('span', [_vm._v("\n              " + _vm._s(column.title.caption) + "\n            ")])]], 2)
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data), function(content) {
    return [_c('tr', {
      class: _vm.onRowCallback(content)
    }, [(_vm.checkbox) ? _c('td', [(_vm.getShowCheckBox(content)) ? _c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isSelected(content)
      },
      on: {
        "change": function($event) {
          return _vm.toggleCheckbox($event.target.checked, content)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return [(_vm.hasCallback(column.content)) ? [_c('td', {
        class: column.content.fieldClass
      }, [_vm._v("\n                " + _vm._s(_vm.callCallback(column.content, content)) + "\n              ")])] : [(column.content.type == undefined) ? [_c('td', {
        class: column.content.fieldClass
      }, [_vm._v("\n                  " + _vm._s(content[column.content.data]) + "\n                ")])] : [_c('td', {
        class: column.content.fieldClass
      }, [(column.content.type == 'tooltip' && column.content.tooltip == undefined) ? [_c('tooltip', {
        attrs: {
          "label": content[column.content.data],
          "type": "default",
          "placement": "left"
        }
      }, [_c('a', {
        staticClass: "is-small"
      }, [_vm._v("\n                        " + _vm._s(_vm.callCallback(column.content, content)) + "\n                      ")])])] : (column.content.type == 'tooltip' && column.content.tooltip.length > 0) ? [_c('tooltip', {
        attrs: {
          "label": _vm.callCallback(column.content, content),
          "type": "default",
          "placement": "left"
        }
      }, [_c('a', {
        staticClass: "is-small"
      }, [_vm._v("\n                        " + _vm._s(_vm.callCallback(column.content, content).substring(0, 25)) + "\n                      ")])])] : (column.content.type == 'link-modal' || column.content.type == 'link-modal|style') ? [(String(_vm.callCallback(column.content, content)).toLowerCase() !== 'false') ? [(column.content.type == 'link-modal|style') ? [_c('a', {
        style: (_vm.$parent[column.content.styleCallback](content)),
        on: {
          "click": function($event) {
            _vm.$parent[column.content.fieldCallback](String(_vm.callCallback(column.content, content)))
          }
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.callCallback(column.content, content)) + "\n                        ")])] : [_c('a', {
        on: {
          "click": function($event) {
            _vm.$parent[column.content.fieldCallback](String(_vm.callCallback(column.content, content)))
          }
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.callCallback(column.content, content)) + "\n                        ")])]] : [_vm._v("\n                      " + _vm._s(_vm.callCallback(column.content, content)) + "\n                    ")]] : (column.content.type == 'field-component') ? [_c(column.content.data, {
        tag: "component",
        attrs: {
          "data": content
        }
      })] : _vm._e()], 2)]]]
    })], 2)]
  })], 2)])]), _vm._v(" "), _c('hyper-table-pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "data": _vm.data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72495668","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/hyper-table/HyperTable.vue
// module id = 1160
// module chunks = 39